import _ from 'lodash';

export default function ActionMap(actions) {
  for (let name in actions) {
    if (!actions.hasOwnProperty(name)) continue;
    let action = actions[name];

    action.async = function () {
      _.defer(() => action.apply(actions, arguments));
    };
  }

  return actions;
}



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/common/js/helpers/ActionMap.js
 **/